import Grid from '../components/grid'
import Container from '../components/ui/container'
import Text from '../components/ui/text'
import { cn } from '../lib/utils'
import { Asset } from '../v2/components/Asset'
import { CMSLink } from '../v2/components/CMSLink'
import Divider from './Divider'
import { Page, Asset as AssetT } from '@telesoft/types/payload-types'
import React from 'react'
import { IoCheckmark } from 'react-icons/io5'
import { RichText } from '../v2/components/RichText'

export type ContentBlockOneBlockProps = Extract<
  Page['blocks'][0],
  { blockType: 'content-block-one' }
>

// todo: refactor
export default function ContentBlockOne(block: ContentBlockOneBlockProps) {
  const { title, description, options, image, bulletPoints, link } = block
  const { split = false, lines = true } = options
  const variant = options.variant || 'right'
  return (
    <Container>
      <Divider />
      <Grid>
        {!split && variant === 'left' && (
          <>
            <div className="col-span-full lg:col-span-6 flex flex-col justify-start items-start">
              <div className="flex flex-col justify-start items-start">
                <Text className="mb-4 max-w-lg xl:max-w-xl" variant="pageHeading">
                  {title}
                </Text>
                <Text className="mb-4 max-w-lg xl:max-w-xl" variant="body">
                  <RichText content={description} />
                </Text>
                <div className="mt-8 grid grid-cols-2 gap-4 max-w-xl">
                  {bulletPoints &&
                    bulletPoints.map((item, i: number) => {
                      return <ListItem key={`item--map--${i}`}>{item.item}</ListItem>
                    })}
                </div>
                <CMSLink {...link} className="float-left mt-8" />
              </div>
            </div>
            <div className="relative col-span-full lg:col-span-6 min-h-[240px] lg:min-h-[400px]">
              {lines && (
                <>
                  <div className="invisible lg:visible absolute inset-0 top-10 -left-10 -bottom-10 right-10 border border-telesoft" />
                  <div className="invisible lg:visible absolute inset-0 top-4 -left-4 -bottom-4 right-4 bg-white" />
                </>
              )}
              <Asset
                resource={image as AssetT}
                imgClassName={cn(`object-cover object-center`, {
                  'bg-contain': options.containImage,
                })}
                fill
              />
            </div>
          </>
        )}
        {!split && variant === 'right' && (
          <>
            <div className="order-last lg:order-first relative col-span-full lg:col-span-6 min-h-[240px] lg:min-h-[400px]">
              {lines && (
                <>
                  <div className="invisible lg:visible absolute inset-0 top-10 -right-10 -bottom-10 left-10 border border-telesoft" />
                  <div className="invisible lg:visible absolute inset-0 top-4 -right-4 -bottom-4 left-4 bg-white" />
                </>
              )}
              <Asset
                resource={image as AssetT}
                imgClassName={cn(`object-cover object-center`, {
                  'bg-contain': options.containImage,
                })}
                fill
              />
            </div>
            <div className="col-span-full lg:col-span-6 flex flex-col justify-start items-end">
              <div className="flex flex-col justify-start items-start">
                <Text className="mb-4 max-w-lg xl:max-w-xl" variant="pageHeading">
                  {title}
                </Text>
                <Text className="mb-4 max-w-lg xl:max-w-xl" variant="body">
                  <RichText content={description} />
                </Text>
                <div className="mt-8 grid grid-cols-2 gap-4 max-w-xl">
                  {bulletPoints &&
                    bulletPoints.map((item: any, i: number) => {
                      return <ListItem key={`item--map--${i}`}>{item.item}</ListItem>
                    })}
                </div>
                <CMSLink {...link} className="float-left mt-8" />
              </div>
            </div>
          </>
        )}

        {split && (
          <>
            <div className="col-span-full flex flex-col justify-start items-start">
              <div className="flex flex-col justify-start items-start">
                <Text className="mb-4 " variant="pageHeading">
                  {title}
                </Text>
                <Text className="mb-4 " variant="body">
                  <RichText content={description} />
                </Text>
                <div className="mt-8 grid grid-cols-2 gap-4 ">
                  {bulletPoints &&
                    bulletPoints.map((item, i: number) => {
                      return <ListItem key={`item--map--${i}`}>{item.item}</ListItem>
                    })}
                </div>
                <CMSLink {...link} className="float-left mt-8" />
              </div>
            </div>

            <div className="relative col-span-full min-h-[240px] lg:min-h-[400px]">
              {lines && (
                <>
                  <div className="invisible lg:visible absolute inset-0 top-10 -left-10 -bottom-10 right-10 border border-telesoft" />
                  <div className="invisible lg:visible absolute inset-0 top-4 -left-4 -bottom-4 right-4 bg-white" />
                </>
              )}
              <Asset
                resource={image as AssetT}
                imgClassName={cn(`object-cover object-center`, {
                  'bg-contain': options.containImage,
                })}
                fill
              />
            </div>
          </>
        )}
      </Grid>
      <Divider />
    </Container>
  )
}

export function ListItem({ children }: { children: React.ReactNode }) {
  return (
    <div className="col-span-full md:col-span-1 flex justify-start items-center">
      <div className="w-4 h-auto mr-3 border-b border-black border-t">
        <IoCheckmark className="text-telesoft" />
      </div>
      <Text className="font-medium text-black">{children}</Text>
    </div>
  )
}
